import { Block, BLOCKS, Document, helpers, Inline, Text, TopLevelBlock } from '@contentful/rich-text-types';
import { IRichText } from '@belong/types';
import { Entry } from 'contentful';
import { FMoleculeRichText, IEntryMoleculeRichText } from '../molecules';

export interface IContentfulTableEntry {
  enableHeaderColumn: boolean;
  enableHeaderRow: boolean;
  caption: string;
  footnoteId?: string;
  footnotes?: Entry<IEntryMoleculeRichText>[];
  table: Document;
}

type Cell = Document;
type Row = Cell[];

export interface IContentfulTable {
  bodyRows?: Row[];
  caption: string;
  enableHeaderColumn: boolean;
  footnoteId?: string;
  footnotes?: IRichText[];
  headerRow?: Row;
}

const isTopLevelBlock = (cell: Block | Inline | Text): cell is TopLevelBlock => cell.nodeType === BLOCKS.PARAGRAPH;

export const FTable = (data: Entry<IContentfulTableEntry>): IContentfulTable => {
  const { enableHeaderRow, footnotes, table, ...otherFields } = data.fields;

  const rawTable = table.content.find(({ nodeType }) => nodeType === BLOCKS.TABLE);

  if (!rawTable) {
    return otherFields;
  }

  const rows: Row[] = rawTable.content.filter(helpers.isBlock).map(
    row =>
      row.content
        .filter(helpers.isBlock)
        .map(cell => {
          if (!isTopLevelBlock(cell.content[0])) {
            return;
          }

          return {
            content: [cell.content[0]],
            data: {},
            nodeType: BLOCKS.DOCUMENT
          } satisfies Cell;
        })
        .filter(Boolean) as Cell[]
  );

  const bodyRows = enableHeaderRow ? rows.slice(1) : rows;
  const headerRow = enableHeaderRow ? rows[0] : undefined;

  return { ...otherFields, bodyRows, headerRow, footnotes: footnotes?.map(FMoleculeRichText) };
};
